// Important: Please do not delete storage keys.
// When they're out of use, please mark them as deprecated
// and they can be commented out. This is to ensure that we
// don't accidentally reuse keys.

export namespace StorageKeys {
    // Storage Keys that are scoped by user/account (DSID).
    export enum User {
        // Recently searched items for the search landing page
        RecentlySearchedItems = 'RecentlySearchedItems',
        SortBy = 'SortBy',
    }

    // Storage Keys that are scoped by device.
    export enum Device {}
}

export type StorageKey = StorageKeys.User | StorageKeys.Device;
